import { useSelector } from 'react-redux';
import { FlexContainer } from '@taxdown/piccolo-web';
import StorageService from 'Services/storage';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { userAuthSelector } from 'Store/modules/auth/selectors';
import { useGetUserCustomerData } from 'Containers/Datagathering/views/DgTypeForm/hooks';
import { PREVIOUS_YEAR_STORAGE_KEY } from 'Containers/PreviousYears/types';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { plansNameMapping, PLAN_SHORT_NAME_DICTIONARY } from 'Constants/plans';
import { PREVIOUS_YEAR_EFIRMA_TYPEFORM } from 'Constants/typeformLinks';
import * as Styled from './styles';

const PreviousYearTypeForm = (): JSX.Element => {
  const user = useSelector(userAuthSelector);
  const customer = useGetUserCustomerData();
  const previousYearAmount = useSelector(routeStateSelector);
  const previousYearStorageAmount = StorageService.getItem(PREVIOUS_YEAR_STORAGE_KEY);

  return (
    <OneColLayout>
      <FlexContainer>
        <Styled.Iframe
          id={`${PREVIOUS_YEAR_EFIRMA_TYPEFORM}id_usuario=${customer?.userId || user?.id}&plan=${
            plansNameMapping(customer?.activePlan?.name) || PLAN_SHORT_NAME_DICTIONARY.BASIC
          }&refund=${previousYearAmount?.amount || previousYearStorageAmount}`}
        />
      </FlexContainer>
    </OneColLayout>
  );
};

export default PreviousYearTypeForm;
